// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-prev-module--wrapper--f7341","icon":"carousel-prev-module--icon--bc171"};